var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-update-bar"},[_vm._v("\n    "+_vm._s(_vm.$t('update_bar.text'))+"\n    "),_c('button',{staticClass:"reload-button",on:{"click":_vm.doReload}},[_vm._v("\n        "+_vm._s(_vm.$t('update_bar.button'))+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }